






























metaMixin = require '@/mixins/meta'

import GeotapLogo from '@/components/GeotapLogo'
import Footer from '@/components/Footer'

export default {
  name: 'privacy-page',

  mixins: [metaMixin]

  components: 
    'geotap-logo': GeotapLogo
    'lucre-footer': Footer 

  data: -> 
    meta: 
      title: 'Privacy Policy for GeoTap Game'
      description: ''
      image: 'http://geotapgame.com/static/geotap-game-lucre-games-lowpoly-3d-casual-relaxing-mobile-game.png'
      route: '/privacy'
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/Privacy.vue